export const isFeatureEnabled = (): boolean => {
  if (localStorage.getItem('account-consent-enabled')) return true
  return false
}
export const isFeatureNotDisabled = (): boolean => {
  if (localStorage.getItem('account-consent-disabled')) return false
  return true
}
